import { styled } from '@mui/material/styles';
import { Button as BaseButton } from 'components/buttons';
import { Card } from 'components/cards';
import { Loader } from 'components/styledComponents';

export const UploadLoader = styled(Loader)(() => ({
  height: '100%'
}));

export const BillingCard = styled(Card)(() => ({
  minWidth: '0px',
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  height: '100%'
}));

export const Title = styled('div')(({ theme }) => ({
  fontSize: theme.fontSize.medium,
  marginLeft: '15px',
  marginBottom: '5px',
  color: theme.color.primary.main
}));

export const FlexBox = styled('div')(({ mt }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  marginTop: mt ? `${mt}px` : '0px'
}));

export const CardsSubContainer = styled('div')(({ size }) => ({
  display: 'flex',
  flexDirection: 'column',
  marginTop: '25px',
  width: size ? `${parseFloat(size) * 10}%` : 0,
  alignSelf: 'stretch',
  '@media (max-width: 955px)': {
    width: '100%'
  }
}));

export const ErrorMessage = styled('p')(() => ({
  color: 'red'
}));

export const Message = styled('p')(({ theme, mt, small }) => ({
  marginTop: mt ? `${mt}px` : '0px',
  color: theme.color.primary.main,
  fontSize: small ? theme.fontSize.small : 'medium'
}));

export const ButtonContainer = styled('div')(() => ({
  margin: '5px',
  display: 'flex',
  flexDirection: 'row-reverse',
  width: '100%',
  flexWrap: 'wrap'
}));

export const Button = styled(BaseButton)(({ disabledColor }) => ({
  margin: '15px',
  '&:disabled, &[disabled]': {
    background: disabledColor || '#F5F5F5',
    color: disabledColor ? 'white' : '#CCCCCC',
    '&:hover': {
      background: disabledColor || '#F5F5F5',
      color: disabledColor ? 'white' : '#CCCCCC'
    }
  }
}));

export const ButtonLink = styled(BaseButton)(({ theme }) => ({
  background: 'none !important',
  border: 'none',
  padding: '0 !important',
  color: theme.color.primary.main
}));

export const TextContainer = styled('div')(({ mt }) => ({
  marginTop: mt ? `${mt}px` : '0px',
  display: 'flex',
  flexDirection: 'column'
}));

// RTEXT-751
export const Text = styled('div')(({ theme, width, mt, $bold }) => ({
  ...(width && { width: `${width}px` }),
  marginTop: mt ? `${mt}px` : '0px',
  fontWeight: $bold ? theme.fontWeight.bold : theme.fontWeight.normal
}));
